import React from 'react';
import { IconAndText } from '@blueprint/ui';

import { getCountContent } from './ListingCounts.helpers';
import { ListingCountList } from './ListingCounts.styles';
import { CountProps, ListingCountsProps } from './ListingCounts.types';

export const Count = ({ icon, count, label: type, compact }: CountProps) => {
    if (!count) {
        return <></>;
    }
    return (
        <li data-testid={`${type}-count`}>
            <IconAndText
                isInline
                iconId={icon}
                content={compact ? count : getCountContent(count, type)}
                iconColor="text-body"
                contentColor="text-title"
                size="medium"
            />
        </li>
    );
};

const ListingCounts = ({
    data: { numBathrooms, numBedrooms, numLivingRooms },
    compact = false
}: ListingCountsProps) => {
    if (!numBathrooms && !numBedrooms && !numLivingRooms) {
        return <></>;
    }
    return (
        <ListingCountList data-testid="listing-preview-counts">
            <Count
                icon="bed"
                label="bed"
                count={numBedrooms}
                compact={compact}
            />
            <Count
                icon="bath"
                label="bath"
                count={numBathrooms}
                compact={compact}
            />
            <Count
                icon="chair"
                label="reception"
                count={numLivingRooms}
                compact={compact}
            />
        </ListingCountList>
    );
};

export default ListingCounts;
